@switch (template) {
  @case (108) {
  <app-template-108 [template]="template" [authReady]="authReady" [parameters]="parameters" [isResuming]="isResuming">
  </app-template-108>
  }
  @case (2134) {
  <app-template-2134 [template]="template" [authReady]="authReady" [parameters]="parameters" [isResuming]="isResuming">
  </app-template-2134>
  }
  @default {
  <app-template-default [template]="template" [parameters]="parameters"></app-template-default>
  }
}